<template>
  <transition name="fade" v-if="show" v-bsl="show" >
    <div class="aoformsample" @click="$store.commit('closeSample')">
      <CloseBtn :toLeft="true" color='white' @click.native="$store.commit('closeSample')" />
      <img @click.stop :src="url" class="aoformsample__img">
    </div>
  </transition>
</template>

<script>
import CloseBtn from './CloseBtn.vue'

export default {
  components: { CloseBtn },
  computed: {
    show(){
      return this.$store.state.sampleWatching
    },
    url(){
      return this.$store.state.sampleUrl
    }
  }
}
</script>

<style lang="sass">
.fade-enter,.fade-leave-to
  opacity: 0
.fade-enter-active, .fade-leave-active
  transition: .3s ease-out  
.aoformsample
  position: fixed
  background: rgba(0,0,0,.6)
  z-index: 50
  width: 100%
  top: 0
  left: 0
  right: 0
  bottom: 0
  --popuppadding: 40px
  padding: 32px var(--popuppadding)
  overflow-y: auto
  &__img
    margin-top: 48px
    display: block
    width: auto
    max-width: 100%
    margin-left: auto
    margin-right: auto
  @include for-mob
    --popuppadding: 24px
    padding: var(--popuppadding)
    &__img
      margin-top: 24px
</style>